import { render, staticRenderFns } from "./ChangeLogHistory.vue?vue&type=template&id=190dc964&scoped=true"
import script from "./ChangeLogHistory.vue?vue&type=script&lang=js"
export * from "./ChangeLogHistory.vue?vue&type=script&lang=js"
import style0 from "./ChangeLogHistory.vue?vue&type=style&index=0&id=190dc964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190dc964",
  null
  
)

export default component.exports